import { DashboardLayout } from '@/components/layout/DashboardLayout';
import EllaAdvisorConsole from '@/components/compliance/EllaAdvisorConsole';
import { useTenantStore } from '@/hooks/useTenantStore';

export default function EllaAdvisor() {
  const { tenantId } = useTenantStore();

  if (!tenantId) {
    return (
      <DashboardLayout>
        <div className="p-6 text-center text-muted-foreground">
          Please select a company to use Ella AI Advisor
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Ella AI Advisor</h1>
          <p className="text-muted-foreground mt-2">
            Get instant answers to your compliance and governance questions.
          </p>
        </div>
        <div data-tour="ella-advisor">
          <EllaAdvisorConsole companyId={tenantId} />
        </div>
      </div>
    </DashboardLayout>
  );
}
